"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const drop_down_1 = __importDefault(require("@clayui/drop-down"));
const DropDownDivider_1 = __importDefault(require("./DropDownDivider"));
const DropDownGroup_1 = __importDefault(require("./DropDownGroup"));
const DropDownItem_1 = __importDefault(require("./DropDownItem"));
const types_1 = __importDefault(require("./types"));
function DropDown(_a) {
    var { alignmentPosition = types_1.default.BottomLeft, closeOnClick = false, closeOnClickOutside = true, children, items, search = '', placeholder = 'Search...', searchable = false, onSearchChange } = _a, restProps = __rest(_a, ["alignmentPosition", "closeOnClick", "closeOnClickOutside", "children", "items", "search", "placeholder", "searchable", "onSearchChange"]);
    return (react_1.default.createElement(drop_down_1.default, Object.assign({}, restProps, { alignmentPosition: alignmentPosition, closeOnClick: closeOnClick, closeOnClickOutside: closeOnClickOutside }),
        searchable && react_1.default.createElement(drop_down_1.default.Search, { value: search, placeholder: placeholder, onChange: onSearchChange }),
        react_1.default.createElement(drop_down_1.default.ItemList, { items: items }, children)));
}
DropDown.Divider = DropDownDivider_1.default;
DropDown.Group = DropDownGroup_1.default;
DropDown.Item = DropDownItem_1.default;
exports.default = DropDown;
//# sourceMappingURL=DropDown.js.map